import { render, staticRenderFns } from "./EntityNotes.vue?vue&type=template&id=ae5a3826&"
import script from "./EntityNotes.vue?vue&type=script&lang=js&"
export * from "./EntityNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports